module.exports = __webpack_public_path__ + "static/media/rightIMG.10214d53.jpg";